/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ComputersActionIds {
    FileLevelRestorePortalTBD = 'FileLevelRestorePortalTBD',
}
